import { type FC } from 'react';

import {
  FOOTER_MODALS_TYPE,
  FooterModalProps
} from '@/components/AdvertisePayments/components/Footer/Footer.types';
import { FooterContinue } from '@/components/AdvertisePayments/components/Footer/FooterContinue';
import { PayWithDisclaimerFooter } from '@/components/AdvertisePayments/components/Footer/FooterPayWithDisclaimer';

import { FooterCancelContinue } from './FooterCancelContinue';

export const FooterModal: FC<FooterModalProps> = ({
  footerVariant,
  isLoading = false,
  disabled,
  onContinue,
  onCancel,
  onPay,
  isAddBalance
}) => {
  switch (footerVariant) {
    case FOOTER_MODALS_TYPE.CANCEL_CONTINUE:
      return <FooterCancelContinue onContinue={onPay} onCancel={onCancel} />;
    case FOOTER_MODALS_TYPE.CONTINUE:
      return <FooterContinue onContinue={onContinue} />;

    case FOOTER_MODALS_TYPE.PAY_WITH_DISCLAIMER:
      return (
        <PayWithDisclaimerFooter
          isAddBalance={isAddBalance}
          disabled={disabled}
          isLoading={isLoading}
          onPay={onPay}
        />
      );

    default:
      return null;
  }
};
